"use strict";

import { showMore } from "./components/showMore";
import { initializeCarousel } from "./components/initializeCarousel";
import { breakpoints } from "./helpers/breakpoints";
import { debounce } from "lodash";

const CONSTANTS = {
    DEFAULT_SPACING: 32,
};

const carouselConfig = {
    slidesPerView: 1.3,
    pagination: false,
    navigation: false,
    scrollbar: false,
    breakpoints: {
        [breakpoints.lg]: {
            slidesPerView: 1.3,
            spaceBetween: CONSTANTS.DEFAULT_SPACING,
        },
    },
};

const isMobile = () => $(window).width() < breakpoints.lg;

$(() => {
    loadFacultyCardsImages().then(initializePage);
    setupResizeHandler();
});

const initializePage = () => {
    initializeShowMore();
    removeSkeleton();
    initializeCarouselsIfNeeded();
    $(".cards-wrapper").addClass("loaded");
    $(".faculty-card").on("click", showFlyout);
};

const initializeShowMore = () => {
    const $wrappers = $(".faculty-content-layout-grid .cards-wrapper");

    $wrappers.each(function () {
        const $this = $(this);
        const minHeight = calculateShowMoreMinHeightForWrapper($this);

        if (minHeight) {
            showMore($this, {
                minHeight,
                buttonTxtMore: "View All",
                buttonTxtLess: "View Less",
                buttonCss:
                    "faculty-content-layout-view-all-btn btn mt-4 mx-auto w-100",
                animationSpeed: 0 // the content is too expensive to animate and causes a noticeable delay.
            });
        }
    });
};

const calculateShowMoreMinHeightForWrapper = ($wrapper) => {
    const $children = $wrapper.children();
    if ($children.length < 6) return undefined; // Ensure there are at least 6 cards

    const firstCardHeight = $children.eq(0).height();
    const sixthCardHeight = $children.eq(5).height();

    const totalHeight = firstCardHeight + sixthCardHeight;

    return totalHeight > 0 ? totalHeight + CONSTANTS.DEFAULT_SPACING : undefined;
};

const loadFacultyCardsImages = () =>
    new Promise((resolve) => {
        const $images = $(".faculty-card-img img", ".cards-wrapper");

        if ($images.length === 0) return resolve();

        const checkImagesLoaded = () => {
            const allLoaded = $images.toArray().every((img) => img.complete);
            allLoaded ? resolve() : setTimeout(checkImagesLoaded, 200);
        };

        checkImagesLoaded();
    });

const removeSkeleton = () => {
    $(".faculty-content-layout-grid").removeSkeleton();
};

const resetComponentStyles = ($element) => {
    if (!$element || !$element.length) return;

    const stylesToRemove = [
        "minHeight",
        "maxHeight",
        "overflow",
        "width",
        "height",
    ];
    $element.siblings(".faculty-content-layout-view-all-btn").remove();

    stylesToRemove.forEach((style) => $element.css(style, ""));
};

const initializeCarouselsIfNeeded = () => {
    const selector = ".faculty-content-layout-grid";
    $(selector).each(function () {
        const $this = $(this);

        if (isMobile()) {
            initializeCarouselIfNotInitialized($this);
        } else {
            destroyCarouselIfInitialized($this);
        }
    });
};

const initializeCarouselIfNotInitialized = ($element) => {
    if (!$element.hasClass("swiper-initialized")) {
        resetComponentStyles($element.find(".cards-wrapper"));
        initializeCarousel($element[0], carouselConfig);
    }
};

const destroyCarouselIfInitialized = ($element) => {
    if ($element.hasClass("swiper-initialized")) {
        $element[0].swiper.destroy(true, true);
    }
};

const setupResizeHandler = () => {
    $(window).on(
        "resize",
        debounce(() => {
            initializeCarouselsIfNeeded();
            initializeShowMore();
        }, 300),
    );
};

const showFlyout = (e) => {
    const $flyout = $(".faculty-flyout").clone();
    const data = $(e.currentTarget).data();
    const modalTitle = {
        modalTitle: $(".faculty-layout-text").data("modal-title"),
    };

    populateFlyout($flyout, { ...data, ...modalTitle }).then(() => {
        $flyout.modal("show");
        removeModalOnClose($flyout);
    });
};

const populateFlyout = ($flyout, data) =>
    new Promise((resolve) => {
        const fullName = `${data.firstName} ${data.lastName}`;
        data.fullName = fullName;

        const dataToModalMap = {
            cardImg: ".faculty-card-img img",
            cardTitle: ".faculty-card-title",
            fullName: ".faculty-card-name",
            position: ".faculty-card-focus",
            company: ".faculty-card-school",
            bioUrl: ".modal-footer .view-bio-btn",
            viewAllUrl: ".modal-footer .view-courses-btn",
            modalTitle: ".modal-title",
            bio: ".faculty-card-bio",
        };

        $.each(dataToModalMap, (key, selector) => {
            if (key === "cardImg") {
                $flyout.find(selector).attr("src", data[key]).attr("alt", data.fullName);
            } else if (key === "bioUrl" || key === "viewAllUrl") {
                data[key] ? $flyout.find(selector).attr("href", data[key]) : $flyout.find(selector).parent().empty();
            } else {
                $flyout.find(selector).html(data[key]);
            }
        });

        // Hide the modal-footer if there are no links
        if (data.showInFacultyDirectory === false) {
            $flyout.find(".modal-footer").hide();
        }

        resolve();
    });

const removeModalOnClose = ($modal) => {
    $modal.on("hidden.bs.modal", function () {
        $(this).remove();
    });
};
